module.exports = __webpack_public_path__ + "static/media/truck.693a5dfe.svg";